import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import "../../components/AboutKeyChallenge/AboutKeyChallenge.css";
import imageSrc from "../../assets/images/5.png";
import historyImage from '../../assets/images/6.png';
import { FaShieldAlt, FaChartLine, FaWallet, FaGlobe } from "react-icons/fa";

const challenges = [
  {
    title: "Market Fragmentation",
    description: "Buyers and sellers operate in disconnected markets, making transactions inefficient and costly.",
  },
  {
    title: "Lack of Transparency",
    description: "Pricing inconsistencies and unreliable sourcing make procurement unpredictable.",
  },
  {
    title: "Payment Risks",
    description: "Delayed payments, defaults, and lack of financial security create cash flow problems.",
  },
  {
    title: "Supply Chain Inefficiencies",
    description: "Production delays due to poor coordination between buyers and suppliers.",
  },
  {
    title: "Limited Financial Support",
    description: "Access to working capital remains a challenge, limiting business expansion.",
  },
];

const benefits = [
  {
    icon: require("../../assets/images/icon1.png"), 
    title: "Transact With Confidence",
    description: "Verified participants ensure secure, transparent, and reliable dealings."
  },
  {
    icon: require("../../assets/images/icon2.png"),
    title: "Enhance Operational Efficiency ",
    description: "Digital tools eliminate delays, reduce costs, and provide real-time insights."
  },
  {
    icon: require("../../assets/images/icon3.png"),
    title: "Strengthen Financial Access",
    description: "Integrated financial solutions empower businesses with better credit and payment options."
  },
  {
    icon: require("../../assets/images/icon4.png"),
    title: "Expand Market Reach ",
    description: "A structured ecosystem opens doors to broader networking and growth opportunities."
  }
];


const AboutKeyChallenge = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleChallenge = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div className="challenges-section custom-inner-space custom-container-upper">
        <h2 className="challenges-heading font-merriweather">Key Challenges</h2>
        <div className="challenges-container font-merriweather">
          {challenges.map((item, index) => (
            <div key={index} className="challenge-item">
              <div
                className="challenge-title"
                onClick={() => toggleChallenge(index)}
              >
                <span>{item.title}</span>
                {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
              </div>
              {openIndex === index && (
                <p className="challenge-description">{item.description}</p>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="stelmart-section  custom-container-upper">
        <h2 className="stelmart-heading font-merriweather">
          <span className="about-text-about ">How</span> <span className="stelmart-text-about">Stelmart</span> Bridges the Gap?
        </h2>
        <p className="stelmart-description custom-inner-space font-poppins ">
        Stelmart redefines how business is done in the steel and polymer sectors by bringing together buyers, sellers, and financial institutions on one easy-to-use platform going beyond traditional market platforms.
        </p>
        <p className="stelmart-description custom-inner-space font-poppins">
        It’s designed to empower businesses of all sizes with tools that simplify every step of the buying and selling journey. Whether you're a manufacturer looking to reach a broader audience or a buyer seeking the best deals, Stelmart makes it possible, effortlessly.
        </p>
      </div>
      <div className="stelmart-difference-section custom-container-upper">
        <div className="stelmart-difference-container custom-inner-space ">
          <div className="stelmart-left">
            <h2 className="stelmart-difference-heading font-merriweather">
            <span className="about-text-about ">How</span> <span className="stelmart-text-about">Stelmart</span> Create A Difference?
            </h2>
            <p className="stelmart-difference-paragraph font-poppins">
            Despite the industry's progress, challenges such as market fragmentation, inefficiencies, and trust issues persist. We tackle these issues by creating a streamlined digital platform that connects buyers, sellers, and financial institutions within India.                <br /><br />
            </p>
            <p className="stelmart-difference-paragraph font-poppins">
            We eliminate fragmentation by bringing all stakeholders onto a single platform. Verified buyers and sellers ensure trust and transparency in every transaction. The platform simplifies operations through secure digital payments, real-time tracking, and seamless negotiations. </p>
            <p className="stelmart-difference-paragraph font-poppins">
            Businesses gain access to valuable market insights, enabling data-driven decisions. We aim to empower businesses to scale within the Indian market by providing a more efficient and connected trading experience.</p>
            <p className="stelmart-difference-paragraph font-poppins">
            Stelmart was built to address these exact challenges, offering an innovative approach that connects key stakeholders, simplifies transactions, and provides valuable insights into the steel and polymer industries.</p>
          </div>

          <div className="stelmart-right">
            <img
              src={imageSrc}
              alt="Stelmart Platform"
              className="stelmart-image"
            />
          </div>
        </div>
      </div>
      <div className="history-section">
        <div className="history-heading">
          <h2 className="font-merriweather">
          <span className="story">The </span><span className="stelmart-text-about">Stelmart</span> <span className="story">Story</span>
          </h2>
        </div>
        <div className="history-grid custom-inner-space custom-container-upper">
          <div className="history-image">
            <img src={historyImage} alt="History" />
          </div>
          <div className="history-content">
            <h3 className="font-merriweather">Redefining the Industry</h3>
            <p className="font-poppins">
            Stelmart was founded by Rahul Sharma and Shankar Sundararaman with a vision to redefine the steel and polymer industries through a seamless, digitalized ecosystem, inconsistent pricing, fragmented supply chains, and transactional complexities, they set out to build a structured platform that fosters trust, enhances efficiency and drives sustainable growth.
          
            </p>
          </div>
        </div>
        <div>
          <p className="font-poppins custom-inner-space history-contents">
          Rahul Sharma, with his expertise in business development and operations, ensures that they deliver a robust and scalable marketplace. Shankar Sundararaman, utilizing his strengths in trade, retail, and process optimization, driving innovation and strategic expansion.             <br /><br />
          Stelmart streamlines procurement, sales, and payment processes by integrating buyers, sellers, and financial institutions onto a single, secure platform. This enables businesses of all sizes to:  
        </p>
        </div>
      </div>
      <div className="benefits-section custom-inner-space">
        <div className="benefits-container ">
          {benefits.map((benefit, index) => (
           <div key={index} className="benefit-box">
           <div className="benefit-icon">
             <img src={benefit.icon} alt={benefit.title} /> 
           </div>
           <h3 className="benefit-title font-merriweather">{benefit.title}</h3>
           <p className="benefit-description font-poppins">{benefit.description}</p>
         </div>
         
          ))}
        </div>
        <p className="font-poppins history-contents2">
        By redefining the industry with a technology-driven approach, Stelmart is not just a marketplace—it’s a catalyst for long-term business success.
        </p>
      </div>
    </div>
  );
};

export default AboutKeyChallenge;
